export const STORY_POINT_WRAPPER_TEST_ID =
	'software-board.board-container.board.card-container.card.story-point-field.wrapper';
